module.exports = __webpack_public_path__ + "static/media/img-trending-products-plotted.36a038ea.png";